import { t } from "i18next";
import { DataTableData } from "../../../../components/deprecated/DataTable/DataTable";
import { DataObjectHelper, DataObjectType } from "../DataObjects/DataObjectHelper";
import { SensorValue } from "@pages/Energy/EnergyTypes";
import { FirebaseDataDateField } from "../DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataNumberField } from "../DataObjectField/Generic/FirebaseDataNumberField";

export class SensorDataHelper extends DataObjectHelper<SensorValue> {
  id = () => "sensorData";
  displayName = () => t("main.sensor");

  value = new FirebaseDataNumberField<SensorValue>("value", t("main.value"), (data) => data.value);
  fromDate = new FirebaseDataDateField<SensorValue>("date", t("main.date"), (data) => data.fromDate);

  allFields() {
    return [this.fromDate, this.value];
  }
  getAllDataTableDatas(documents: DataObjectType[]): DataTableData[] {
    return [];
  }
}

